(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    

(function () {

  /* SCROLL TO PRODUCT ON ANCHOR */
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener("DOMContentLoaded", () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: "instant" });
    }, { once:true });
  }

  /* FULL CARD CLICK - EXCLUDE BUTTONS */
  document.addEventListener("click", function(e) {
    const card = e.target.closest(".carousel-card");
    
    if (!card) return;

    if (e.target.closest(".add-to-cart-card-button") || 
        e.target.closest(".add-to-cart-card-wrapper") ||
        e.target.closest(".wishlist-button") ||
        e.target.closest(".wishlist-box") ||
        e.target.closest("button") ||
        e.target.closest("form")) {
      return;
    }

    if (card && card.dataset.productUrl) {
      window.location.href = card.dataset.productUrl;
    }
  });

  /* WISHLIST SYSTEM - FIXED VERSION */
function getWishlist() {
  return JSON.parse(localStorage.getItem("wishlist_items") || "[]");
}

function saveWishlist(list) {
  localStorage.setItem("wishlist_items", JSON.stringify(list));
}

document.addEventListener("DOMContentLoaded", () => {
  const saved = getWishlist();
  document.querySelectorAll(".carousel-card").forEach(card => {
    const id = card.dataset.variant;
    if (saved.includes(id)) {
      // Add active class to BOTH wishlist buttons in the card
      const wishlistButton = card.querySelector(".wishlist-button");
      const wishlistBox = card.querySelector(".wishlist-box");
      if (wishlistButton) wishlistButton.classList.add("active");
      if (wishlistBox) wishlistBox.classList.add("active");
    }
  });
});

document.addEventListener("click", function(e) {
  // Target BOTH .wishlist-button AND .wishlist-box
  const btn = e.target.closest(".wishlist-button, .wishlist-box");
  if (!btn) return;

  e.stopPropagation();
  e.preventDefault();

  const card = btn.closest(".carousel-card");
  const variantId = card.dataset.variant;

  let wishlist = getWishlist();

  // Find both wishlist elements in this card
  const wishlistButton = card.querySelector(".wishlist-button");
  const wishlistBox = card.querySelector(".wishlist-box");

  if (wishlist.includes(variantId)) {
    // Remove from wishlist
    wishlist = wishlist.filter(id => id !== variantId);
    if (wishlistButton) wishlistButton.classList.remove("active");
    if (wishlistBox) wishlistBox.classList.remove("active");
  } else {
    // Add to wishlist
    wishlist.push(variantId);
    if (wishlistButton) wishlistButton.classList.add("active");
    if (wishlistBox) wishlistBox.classList.add("active");
  }

  saveWishlist(wishlist);
});

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    

(function () {

  /* SCROLL TO PRODUCT ON ANCHOR */
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener("DOMContentLoaded", () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: "instant" });
    }, { once:true });
  }

  /* FULL CARD CLICK - EXCLUDE BUTTONS */
  document.addEventListener("click", function(e) {
    const card = e.target.closest(".carousel-card");
    
    if (!card) return;

    if (e.target.closest(".add-to-cart-card-button") || 
        e.target.closest(".add-to-cart-card-wrapper") ||
        e.target.closest(".wishlist-button") ||
        e.target.closest(".wishlist-box") ||
        e.target.closest("button") ||
        e.target.closest("form")) {
      return;
    }

    if (card && card.dataset.productUrl) {
      window.location.href = card.dataset.productUrl;
    }
  });

  /* WISHLIST SYSTEM */
  function getWishlist() {
    return JSON.parse(localStorage.getItem("wishlist_items") || "[]");
  }

  function saveWishlist(list) {
    localStorage.setItem("wishlist_items", JSON.stringify(list));
  }

  document.addEventListener("DOMContentLoaded", () => {
    const saved = getWishlist();
    document.querySelectorAll(".carousel-card").forEach(card => {
      const id = card.dataset.variant;
      if (saved.includes(id)) {
        const btn = card.querySelector(".wishlist-button");
        if (btn) btn.classList.add("active");
      }
    });
  });

  document.addEventListener("click", function(e) {
    const btn = e.target.closest(".wishlist-button");
    if (!btn) return;

    e.stopPropagation();
    e.preventDefault();

    const card = btn.closest(".carousel-card");
    const variantId = card.dataset.variant;

    let wishlist = getWishlist();

    if (wishlist.includes(variantId)) {
      wishlist = wishlist.filter(id => id !== variantId);
      btn.classList.remove("active");
    } else {
      wishlist.push(variantId);
      btn.classList.add("active");
    }

    saveWishlist(wishlist);
  });

})();

  } catch(e) { console.error(e); }
})();
})();
